import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepTwoLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepTwoLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.memoryStepTwoLevels.data.memoryStepTwoLevelsRandom,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
